import { logger } from 'common/services/logger';
import { monitoring } from 'common/services/monitoring';
import { assert } from 'common/utils/assert';
import type { Effect } from 'store';
import { selectUserAccountId } from 'user/api';

import { natteringJoin_WS, natteringSkip_WS } from '../actions';

export const natteringAcceptedEffect: Effect = (_, { dispatch, getState }) => {
  try {
    const accountId = selectUserAccountId(getState());

    assert(!!accountId);

    dispatch(natteringJoin_WS({ accountId, userId: accountId }));
  } catch (error) {
    logger.error(error);
  }
};

export const natteringSkippedEffect: Effect = (_, { dispatch, getState }) => {
  try {
    const accountId = selectUserAccountId(getState());

    assert(!!accountId);

    dispatch(natteringSkip_WS({ accountId, userId: accountId }));
  } catch (error) {
    logger.error(error);
  }
};

export const natteringAutomaticallySkippedEffect: Effect = () => {
  monitoring.trackAction('broadcast.poor_network_conditions');
};

export const natteringAudioIssueDetectedBeforeJoining: Effect = () => {
  monitoring.trackAction('nattering.automatically_skipped_due_to_audio_issue');
};
